// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2862s","left":"styles_left__3S0-D","right":"styles_right__3UmUj","alert":"styles_alert__pCGQV"};